import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
import { fun_GetKeys } from "@/utils/validate";
import PrintDialog from "../../components/PrintDialog/index.vue";

// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: false,
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regulators: null, // 招标监管部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 温馨提示
      tipList: [
        /* {
           type: "text",
           text: "当状态为“招标人确认中”时，招标人请点击项目名称进入详情后进行操作。"
         }*/
      ],
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "380",
          isShow: true,
          fixed: true,
        },
        {
          label: "状态",
          slotName: "state",
          fixed: true,
          width: "140",
        },
        {
          label: "打印",
          slotName: "print",
          fixed: true,
          width: "140"
        },
        {
          label: "招标组织形式",
          prop: "tenderMethodFlag",
          fixed: true,
          width: "130"
        },
        {
          label: "工程地址",
          prop: "prjAddress",
          width: "300"
        },
        {
          label: "招标人",
          prop: "tenderName",
          width: "280"
        },
        {
          label: "招标代理机构",
          prop: "agencyCorpName",
          width: "280"
        },
        {
          label: "招标联系人",
          prop: "tenderLinkMan",
          width: "280"
        },
        {
          label: "招标监管部门",
          prop: "regulators",
          width: "300"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
    };
  },
  // 注册组件
  components: {
    PrintDialog
  },

  // 模板编译完成
  mounted() {
    // 获取是否为工作台公告流程
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu") ? sessionStorage.getItem("workbenchMenu") : null;
    // 如果用户标识是工作人员或者监管人员
    if (this.userFlag === "工作人员" || this.userFlag === "监管人员" || this.userFlag === "分包合同监管人员") {
      // 清空表头
      this.btnList = [];
    }
    // 获取一览
    this.fun_GetList();
    // 获取工作台状态
    this.fun_GetWorkbenchState();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/tendererSituation/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 获取工作台状态
     */
    fun_GetWorkbenchState(){
      // 请求，获取结果集
      fun_PostAction("/tendererSituation/getWorkbenchState", {}).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 回显table
          this.workbenchState = data.workbenchState;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 跳转详情页面
          this.$router.push({
            path: "/tenderSituationDetail",
            query: { controllerFlag: "insert" }
          });
          break;
        case "修改":
          // 调用修改方法
          this.fun_Edit();
          break;
        default:
          // 调用删除方法
          this.fun_Del();
      }
    },

    /**
     * 修改的方法
     * @author shuhua
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 状态
          var state = this.multipleSelection[0].state;
          // 甲方确认信息编号
          var tenderSignedId = this.multipleSelection[0].tenderSignedId;
          // 甲方确认状态
          var tenderSignedState = this.multipleSelection[0].tenderSignedState;
          // 是否为甲方
          var tenderCorpFlag = this.multipleSelection[0].tenderCorpFlag;
          // 招标组织形式
          var tenderMethod = this.multipleSelection[0].tenderMethod;
          // 如果招标组织形式不是 自行组织
          if (tenderMethod && tenderMethod !== "1") {
            // 则验证若是招标人则不能修改操作
            if (tenderCorpFlag === "01") {
              this.$alert("该项目为委托招标请直接点击项目进入详情进行操作，不能修改项目数据。", "warning");
              return;
            }
          }
          // 状态名称
          var stateName = "";
          // 检查状态
          var checkFlg = true;
          // 提交的场合
          if (state == 'tj') {
            // 状态名称
            stateName = "提交";
            // 存在甲方确认信息的场合
            if (tenderSignedId) {
              // 盖章信息为空的场合
              if (tenderSignedState == 'tj') {
                // 状态名称
                stateName = '招标人确认中';
                // 检查状态
                checkFlg = false;
              } else if (tenderSignedState == 'tg' || tenderSignedState == 'bc') {
                // 状态名称
                stateName = '提交';
                // 检查状态
                checkFlg = false;
              }
            } else {
              checkFlg = false;
            }
          } else if (state == 'tg') {
            // 状态名称
            stateName = "通过";
            // 检查状态
            checkFlg = false;
          }
          // 验证失败的场合
          if (!checkFlg) {
            this.$alert('该项目当前状态为“' + stateName + '”，不能修改！', 'warning');
            return;
          }
          // 状态等于提交
          if (state === "tj") {
            this.$alert('该项目当前状态为“提交”，不能修改！', 'warning');
            return;
          }
          // 获取选择的数据
          var dataObj = this.multipleSelection[0];
          // 跳转详情页面
          this.$router.push({
            path: "/tenderSituationDetail",
            query: {
              controllerFlag: "update",
              id: this.multipleSelection[0].id,
              tenderSignedId: dataObj.tenderSignedId,
              tenderSignedState: dataObj.tenderSignedState,
              state: dataObj.state,
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },

    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过一条
        if (this.multipleSelection.length > 1) {
          // 勾选多条时，提示
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 检查状态
          var checkFlg = true;
          // 状态名称
          var stateName = "";
          // 状态
          var state = this.multipleSelection[0].state;
          // 是否为甲方
          var tenderCorpFlag = this.multipleSelection[0].tenderCorpFlag;
          // 招标组织形式
          var tenderMethod = this.multipleSelection[0].tenderMethod;
          // 如果招标组织形式不是 自行组织
          if (tenderMethod && tenderMethod !== "1") {
            // 则验证若是招标人则不能修改操作
            if (tenderCorpFlag === "01") {
              this.$alert("该项目为委托招标请联系招标代理做删除操作。", "warning");
              return;
            }
          }
          // 提交的场合
          if (state === "tj") {
            // 状态名称
            stateName = "提交";
            // 检查状态
            checkFlg = false;
          } else if (state === "tg") {
            // 状态名称
            stateName = "通过";
            // 检查状态
            checkFlg = false;
          }
          // 验证失败的场合
          if (!checkFlg) {
            this.$alert('该项目当前状态为“' + stateName + '”，不能删除！', 'warning');
            return;
          }
          // 弹出询问confirm
          this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 获取id
            const id = fun_GetKeys(this.multipleSelection);
            // 发起请求，获取结果集
            fun_GetAction("/tendererSituation/delete?id=" + id).then(res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 判断请求是否成功
              if (result) {
                // 查询列表
                this.fun_GetList();
                // 提示删除成功
                this.$message.success(msg);
              } else {
                // 请求失败，提示信息
                this.$message.error(msg);
              }
            });
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },

    /**
     * 打印的方法
     * @author shuhua
     */
    fun_DialogForPrint(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.registrationId;
      // ids
      this.$refs.printDialog.data = data.id;
      // ids
      this.$refs.printDialog.agencyId = data.agencyId;
      // 权限编号
      this.$refs.printDialog.operationNum = "201606061508000008";
      // 招标人且是委托招标
      if(sessionStorage.getItem("loginType") == "201904241041160002" && data.tenderMethod ==='2'){
        // 不显示加盖签章
        this.$refs.printDialog.showBtn = false;
      }
    },

    /**
     * 打印的方法
     */
     fun_DialogPrint(id,agency,tender,agencyRecords,bidder,lock,recordNumber, flag) {
      // 发起请求
      fun_Download("/dialogPrint", {
        controller: "tendererSituationPrint",
        id: id,
        agency: agency,
        tender: tender,
        agencyRecords: agencyRecords,
        lock: lock,
        recordNumber: recordNumber
      }).then(res => {
        const data =  new Blob([res.data], { type: "application/pdf" });
        const reader = new FileReader();
        // 如果文件大小等于0
        if(data.size == 0){
          this.$message.success("文件生成中！");
        }else{
          //
          this.$refs.printDialog.isShow = true;
          // 读取文件
          reader.readAsText(data);
          // 触发onload事件
          reader.onload = () => {
            // json格式数据转换成对象
            if (reader.result.indexOf("result") > -1) {
              const result = JSON.parse(reader.result);
              if (result.result == false) {
                this.$message.error(result.msg);
              }
            } else {
              this.$refs.printDialog.pdfUrl =
                  "./static/pdf/web/viewer.html?file=" +
                  encodeURIComponent(URL.createObjectURL(data));
            }
          };
        }
      });
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 请求参数
      let obj = {
        controllerFlag: "details",
        id: e.val.id
      }
      // 签章状态不为空
      if (e.val.tenderSignedState) {
        // 请求参数
        obj = {
          controllerFlag: "details",
          isTenderSignature: "1",
          id: e.val.id
        }
      }
      obj = { 
        ...obj,
        tenderSignedId: e.val.tenderSignedId,
        tenderSignedState: e.val.tenderSignedState,
        state: e.val.state,
      }
      // 跳转详情页面
      this.$router.push({
        path: "/tenderSituationDetail",
        query: obj,
      });
    },
  }
};
